<p-toast />
<form
  [formGroup]="formGroup"
  (ngSubmit)="nextStep()"
  class="w-full relative mt-3"
>
  <section class="companyInformation">
    <span class="titleSection">Datos empresa</span>
    <div class="info-message p-2 my-2 legend" *ngIf="isRepresentative">
      <p class="text-justify text-sm m-0">
        <i class="pi pi-info-circle mr-1 text-sm"></i>
        Ingrese el CUIT para buscar automáticamente los datos de la empresa. Si
        no encontramos información, podrá completar los datos manualmente.
      </p>
    </div>
    <div class="grid w-full mb-2 mt-3">
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">CUIT<span class="span">*</span></label>
        <p-inputMask
          class="inputLarge"
          mask="99-99999999-9"
          placeholder="99-99999999-9"
          formControlName="companyCuit"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('companyCuit', 'required')
          }"
          (onBlur)="
            isRepresentative || !readOnlyForEmployer
              ? searchCompanyByCuit(formGroup.get('companyCuit')?.value)
              : null
          "
          [style]="
                    readOnlyForEmployer && !isRepresentative
                      ? {
                          'background-color': 'rgb(223, 223, 223)',
                          border: 'none',
                          'box-shadow': 'none',
                        }
                      : {}
                  "
          [readonly]="readOnlyForEmployer && !isRepresentative"
        ></p-inputMask>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyCuit', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Razón social<span class="span">*</span></label
        >
        <input
          placeholder="Razón social"
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          pInputText
          formControlName="razonSocial"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('razonSocial', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>

      <div
        *ngIf="!isRepresentative"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle">Persona<span class="span">*</span></label>
        <input
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="readOnlyForEmployer"
          formControlName="claimantTypePerformance"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Correo electrónico<span class="span">*</span></label
        >
        <input
          placeholder="Correo electrónico"
          type="text"
          pInputText
          formControlName="companyEmail"
          [class.disabled]="readOnlyForEmployer"
          [readonly]="readOnlyForEmployer"
          [ngClass]="{
            'ng-invalid ng-dirty':
              hasErrors('companyEmail', 'required') ||
              hasErrors('companyEmail', 'email')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyEmail', 'required')"
        >
          Este campo es obligatorio
        </div>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyEmail', 'email')"
        >
          Formato de email incorrecto
        </div>
        <small
          class="block text-xs mt-1"
          *ngIf="isRepresentative && activeIndex == 1 && companyFound"
        >
          Si el correo es incorrecto, por favor escriba el correcto
        </small>
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Teléfono</label>
        <input
          placeholder="Teléfono"
          pInputText
          formControlName="companyPhone"
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [appNumberOnlyNoLength]="15"
          maxlength="15"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Calle<span class="span">*</span></label>
        <input
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          placeholder="Calle"
          type="text"
          pInputText
          formControlName="streetCompany"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('streetCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Número<span class="span">*</span></label>
        <input
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          placeholder="Número"
          type="text"
          pInputText
          formControlName="numberCompany"
          [appNumberOnlyNoLength]="6"
          maxlength="6"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('numberCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Piso/Depto</label>
        <input
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          placeholder="Piso/Depto"
          type="text"
          pInputText
          formControlName="floorApartmentCompany"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Torre</label>
        <input
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          placeholder="Torre"
          type="text"
          pInputText
          formControlName="towerCompany"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Código postal<span class="span">*</span></label
        >
        <input
          placeholder="Código postal"
          type="text"
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          pInputText
          formControlName="postalCodeCompany"
          maxlength="6"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('postalCodeCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle" for="claimetProvince" optionLabel="name"
          >Provincia<span class="span">*</span></label
        >
        <input
          *ngIf="companyFound"
          pInputText
          formControlName="provinceCompany"
          placeholder="Provincia"
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
        />
        <p-dropdown
          *ngIf="!companyFound"
          id="claimetProvince"
          [options]="provinces"
          optionLabel="name"
          optionValue="id"
          placeholder="Seleccione su Provincia"
          formControlName="provinceCompany"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('provinceCompany', 'required')
          }"
        >
        </p-dropdown>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('provinceCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Localidad<span class="span">*</span></label>
        <input
          *ngIf="companyFound"
          placeholder="Localidad"
          pInputText
          formControlName="cityCompany"
          [readonly]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
          [class.disabled]="
            readOnlyForEmployer ||
            (isRepresentative && activeIndex == 1 && companyFound)
          "
        />
        <p-dropdown
          *ngIf="!companyFound"
          [options]="localities"
          optionLabel="name"
          optionValue="name"
          [showClear]="false"
          placeholder="Seleccione su localidad"
          formControlName="cityCompany"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('cityCompany', 'required')
          }"
        >
        </p-dropdown>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('cityCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div
        *ngIf="!isRepresentative"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle"
          >Departamento laboral<span class="span">*</span></label
        >
        <p-dropdown
          [options]="departments"
          placeholder="Seleccione una opción"
          optionLabel="name"
          optionValue="id"
          formControlName="departmentId"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('departmentId', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('departmentId', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div *ngIf="isRepresentative" class="grid w-full m-1">
        <div class="col-12 md:col-3 lg:col-3 xl:col-12">
          <label class="text-sm font-bold mr-3"
            >Tipo de persona<span class="span"> *</span></label
          >
        </div>
        <div
          class="col-12 md:col-6 lg:col-6 xl:col-6 flex flex-column xl:flex-row md:flex-row lg:flex-row gap-1"
        >
          <div
            *ngFor="let person of typeOfPerson"
            class="flex align-items-center gap-1"
          >
            <p-radioButton
              [inputId]="person.key"
              [value]="person.name"
              formControlName="type_of_person"
            ></p-radioButton>
            <label
              [for]="person.key"
              class="ml-2 gap-1 mr-3 text-xs font-bold"
              >{{ person.name }}</label
            >
          </div>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('type_of_person', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="flex align-items-center gap-2 mt-3 mb-3">
    <span class="span">*</span>
    <p-checkbox
      (onChange)="onConsentChange($event)"
      [binary]="true"
      formControlName="consent"
      class="check-acceptsElectronicDomicile"
      label="El domicilio electrónico constituido a través de la indicación de un correo electrónico, se considerará a todos los efectos jurídicos como domicilio constituído, siendo válidas y vinculantes las notificaciones, emplazamientos, comunicaciones y citaciones que se practiquen en el mismo, gozando de plena validez y eficacia su constitución."
    />
  </div>

  <section
    *ngIf="
      this.userData?.tipo_actuacion === 'Persona jurídica' &&
      this.userData?.rol !== 'Representante gremial'
    "
    class="personalInformation"
  >
    <p-divider></p-divider>

    <span class="titleSection">Datos personales</span>
    <div class="grid w-full mb-2 mt-3">
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Apellido/s <span class="span">*</span></label>
        <input
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="readOnlyForEmployer"
          pInputText
          formControlName="lastName"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Nombre/s <span class="span">*</span></label>
        <input
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="readOnlyForEmployer"
          pInputText
          formControlName="name"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">CUIL<span class="span">*</span></label>
        <input
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="readOnlyForEmployer"
          pInputText
          formControlName="cuil"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Cargo que ocupa en la empresa<span class="span">*</span></label
        >
        <input
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="true"
          formControlName="claimantPosition"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Correo electronico<span class="span">*</span></label
        >
        <input
          pInputText
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="true"
          formControlName="email"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Teléfono</label>
        <input
          placeholder="Teléfono"
          pInputText
          formControlName="phone"
          [ngClass]="{ disabled: readOnlyForEmployer }"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle" for="fechaNacimiento"
          >Fecha de Nacimiento<span class="span"> *</span></label
        >
        <input
          [value]="formGroup.get('birthday')?.value | date : 'dd/MM/yyyy'"
          pInputText
          [readOnly]="true"
          [ngClass]="{ disabled: readOnlyForEmployer }"
        />
      </div>
    </div>
  </section>

  <section class="attachedFiles mt-3" *ngIf="!isRepresentative">
    <p-divider></p-divider>
    <span class="titleSection">Archivos adjuntos</span>
    <div class="grid w-full mt-3">
      <div class="col-12">
        <label class="labelTitle">Documentos<span class="span">*</span></label>
        <p class="descriptionContent mb-0">
          Cargue el documento que acredite la representación que invoca.
        </p>
      </div>

      <div class="col-12 md:col-8 lg:col-8 xl:col-6">
        <div
          [ngClass]="
            isDragging
              ? 'isDragging dropzone-container h-6rem col-12 '
              : 'dropzone-container h-6rem col-12 '
          "
          (dragover)="onDragOver($event)"
          (drop)="onDropSuccess($event, 'receipt')"
        >
          <input
            #inputFilePfd
            type="file"
            multiple="false"
            (change)="onChange($event, 'receipt')"
            accept=".pdf, .jpg, .png"
          />

          <div
            class="w-full flex align-items-center justify-content-between col-12"
          >
            <img
              class="hidden md:block"
              src="../../../../../../../assets/img/main/file-update.svg"
            />
            <span class="descriptionContent hidden md:block"
              >Arrastre sus documentos aquí o</span
            >
            <p-button
              pRipple
              (click)="inputFilePfd.click()"
              #upload
              class="btnUploadFile mr-1"
              >Elegir archivo</p-button
            >
          </div>
        </div>
        <span class="descriptionContent"
          >Archivos permitidos: JPG / JPEG / WEBP / HEIF / PDF / PNG
        </span>
      </div>
      <div class="col-12 md:col-4 lg:col-4 xl:col-6">
        <div
          class="text-danger p-error"
          *ngIf="
            formGroup.get('file')?.hasError('fileCount') &&
            formGroup.get('file')?.touched
          "
        >
          Se deben subir entre 1 y 12 archivos.
        </div>
        <div
          class="conteiner-UploadRight-pdf"
          *ngFor="let pdf of pdfFiles; let i = index"
        >
          <img
            src="../../../../../../../assets/img/main/icon-image.svg"
            alt=""
            class="icon-imagen"
          />
          <span class="descriptionContent">{{ pdf.name }}</span>
          <p-button
            icon="pi pi-times"
            [rounded]="true"
            [text]="true"
            severity="danger"
            (onClick)="deleteFilePfd(i)"
          ></p-button>
        </div>
      </div>
    </div>
  </section>

  <div class="grid w-full flex justify-content-end">
    <div *ngIf="isRepresentative" class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        (click)="cancel()"
        label="Cancelar"
        class="btn-cancelar sm:text-xs"
      />
    </div>

    <div *ngIf="isRepresentative" class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        (click)="back()"
        label="Atrás"
        class="btn-cancelar sm:text-xs"
      />
    </div>

    <div *ngIf="!isRepresentative" class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        (click)="cancel()"
        label="Cancelar"
        class="btn-cancelar sm:text-xs"
      />
    </div>

    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        label="Siguiente"
        class="btn-siguiente"
        type="submit"
        [disabled]="formGroup.invalid"
      ></p-button>
    </div>
  </div>
</form>
